import { composeIO } from 'react-compose-io'
import { HistoricoControleComissaoPedidoView } from './HistoricoControleComissaoPedido.View'
import { historicoControleComissaoPedidoIO } from './HistoricoControleComissaoPedidoIO'

export const HistoricoControleComissaoPedido = composeIO(HistoricoControleComissaoPedidoView, historicoControleComissaoPedidoIO)
